<template>
    <div class="unified-filter-row" @click.stop>
        <e-select
            :model-value="modelValue"
            placeholder="Select activity type..."
            class="filter-content-text"
            expanded
            @update:modelValue="handleInput"
        >
            <option v-for="activityType in activityTypes" :key="activityType.id" :value="activityType.id">
                {{ activityType.title }}
            </option>
        </e-select>
    </div>
</template>

<script>
import { initialState } from '@/Helpers.js';

export default {
    name: 'ActivityTypeFilterItem',

    emits: ['update:model-value'],

    props: {
        filter: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: [String, Number],
            default: '',
        },
        applyFilter: {
            type: Function,
            required: true,
        },
    },

    computed: {
        activityTypes() {
            return initialState('ActivityTypes');
        },
    },

    methods: {
        handleInput(value) {
            this.$emit('update:model-value', value);
            this.applyFilter(this.filter, value);
        },
    },
};
</script>
